import { getEventOrganizationName, isSmuinEvent } from './eventOrganization';
import { normalizeCityName } from './eventLocationDisplay';

export function getEventProductionName(event) {
  const originalName = String(event?.['Event Name'] || '').trim();
  return isSmuinEvent(event)
    ? originalName.replace(/\s+by\s+Smuin(?:\s+Contemporary)?\s+Ballet\s*$/i, '').trim()
    : originalName;
}

export function getEventSearchTitle(event) {
  return String(event?.['Event Name'] || '').trim();
}

export function getEventSearchKeywords(event) {
  const productionName = getEventProductionName(event);
  const organizationName = getEventOrganizationName(event);
  const city = normalizeCityName(event?.Address?.city || '');
  const categories = Array.isArray(event?.categories) ? event.categories : [];
  const values = [...categories];

  if (isSmuinEvent(event)) {
    values.push(
      'Smuin Ballet',
      'Smuin Contemporary Ballet',
      productionName && `${productionName} Smuin Ballet`,
      city && `Smuin Ballet ${city}`,
      city && `${productionName} ${city}`,
      city && `contemporary ballet ${city}`,
      'contemporary ballet San Francisco Bay Area'
    );
  } else if (organizationName) {
    values.push(organizationName);
  }

  return [...new Set(values.map((value) => String(value || '').trim()).filter(Boolean))];
}

export function isSameEventProgram(current, candidate) {
  if (!current || !candidate) return false;
  if (current.manualProgramId && candidate.manualProgramId) {
    return current.manualProgramId === candidate.manualProgramId;
  }
  return Boolean(
    getEventProductionName(current) &&
    getEventProductionName(current) === getEventProductionName(candidate) &&
    getEventOrganizationName(current) === getEventOrganizationName(candidate)
  );
}

function getEventStartValue(event) {
  const date = String(event?.Date || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return null;

  const time = String(event?.Time || '').trim();
  const twelveHour = time.match(/^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)\b/i);
  const twentyFourHour = time.match(/^(\d{1,2}):(\d{2})\b/);
  let hours;
  let minutes;

  if (twelveHour) {
    hours = Number(twelveHour[1]);
    minutes = Number(twelveHour[2] || 0);
    if (hours < 1 || hours > 12) return null;
    if (twelveHour[3].toUpperCase() === 'PM' && hours < 12) hours += 12;
    if (twelveHour[3].toUpperCase() === 'AM' && hours === 12) hours = 0;
  } else if (twentyFourHour) {
    hours = Number(twentyFourHour[1]);
    minutes = Number(twentyFourHour[2]);
    if (hours > 23) return null;
  } else {
    return null;
  }

  if (minutes > 59) return null;
  return `${date}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

export function getNextRelatedEvents(current, candidates, limit = 4) {
  const currentStart = getEventStartValue(current);
  if (!currentStart || !Array.isArray(candidates) || limit <= 0) return [];

  return candidates
    .map((candidate) => ({ candidate, start: getEventStartValue(candidate) }))
    .filter(({ candidate, start }) =>
      start &&
      start > currentStart &&
      isSameEventProgram(current, candidate)
    )
    .sort((a, b) => a.start.localeCompare(b.start))
    .slice(0, limit)
    .map(({ candidate }) => candidate);
}

export function getRelatedDatesHeading(event) {
  return `More dates for ${getEventSearchTitle(event)}`;
}
